import React from 'react';
import { Eye } from 'lucide-react';

export function FreePreviewBanner() {
  return (
    <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-lg p-4 mb-4" data-testid="free-preview-banner">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
          <Eye className="h-4 w-4 text-emerald-600" />
        </div>
        <div>
          <p className="font-medium text-slate-800">OnSiteHand is free to use</p>
          <p className="text-sm text-slate-600 mt-0.5">
            Search, view full profiles and message tradespeople — no subscriptions, no credits, no paid unlocks.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FreePreviewBanner;
